<div class="container_filter">
    <div class="header">
        <div class="title-description">
            <h2 class="filter-title">
                {{ "comparator.filter.title" | translate }}
            </h2>
            <p class="filter-description">
                {{ "filter.description" | translate }}
            </p>
        </div>
        <button class="close" (click)="close()">
            <img src="assets/icones/close.svg" alt="" />
        </button>
    </div>

    <div class="content">
        <div class="selection">
            <div class="import-and-selected">
                <ng-container *ngIf="comparatorsFilters?.filters?.length > 0">
                    <button class="select-saved-filter" [matMenuTriggerFor]="menu">
                        <img src="assets/icones/import-filter.svg" alt="" />
                        <small>{{ "filter.import" | translate }}</small>
                    </button>
                    <mat-menu #menu="matMenu" class="import-menu">
                        <div class="filter_btn">
                            <span (click)="setFilter(filter)">{{ filter.name }}</span>
                            <button (click)="deleteFilter(filter)">
                                <img src="assets/icones/delete_btn.svg" alt="">
                            </button>
                        </div>
                    </mat-menu>
                </ng-container>
                <div class="applied-filters-count" (click)="clearFilters()">
                    <span class="count">{{ getFiltersCount() }}</span>
                    <span>{{ "filter.applied" | translate }}</span>
                    <img src="assets/icones/clear-filter.svg" alt="" />
                </div>
            </div>
            <div class="filter-group" [class.filter-group-selected]="selectedGroup === 'group_info'">
                <div class="group-title" (click)="selectedGroup = 'group_info'">
                    <img src="assets/icones/info.svg" alt="" />
                    <h3>{{ "comparator.filter.groups.group_info" | translate }}</h3>
                </div>
                <div class="filters">
                    <!-- <div class="filter" *ngIf="filter.groupInfoFilter.name">
                        <span>
                            {{ "comparator.filter.fields.product_name" | translate }} :
                            {{ filter.groupInfoFilter.name }}
                        </span>
                        <img src="assets/icones/clear-filter.svg" alt=""
                            (click)="filter.groupInfoFilter.name = undefined" />
                    </div> -->
                </div>
            </div>

        </div>
        <div class="form" [formGroup]="filterForm">
            <ng-container *ngIf="selectedGroup === 'group_info'">
                <div class="form-title">
                    <img src="assets/icones/info.svg" alt="" />
                    <h3>{{ "comparator.filter.groups." + selectedGroup | translate }}</h3>
                </div>

                <div class="inputs">
                    <div class="field">
                        <label for="name">{{ "comparator.filter.fields.product_name" | translate }}</label>
                        <input id="name" type="text" formControlName="name"
                            [placeholder]="'comparator.filter.fields.product_name' | translate" />
                    </div>
                    <div class="field">
                        <label for="sku">{{ "comparator.filter.fields.sku" | translate }}</label>
                        <input id="sku" type="text" formControlName="sku"
                            [placeholder]="'comparator.filter.fields.sku' | translate" />
                    </div>
                    <div class="inputs-pair">
                        <div class="field">
                            <label for="imported_price_min">{{ "comparator.filter.fields.imported_price_min" | translate
                                }}</label>
                            <input id="imported_price_min" type="number" min="0" formControlName="imported_price_min"
                                [placeholder]="'comparator.filter.fields.imported_price_min' | translate" />
                        </div>
                        <div class="field">
                            <label for="imported_price_max">{{ "comparator.filter.fields.imported_price_max" | translate
                                }}</label>
                            <input id="imported_price_max" type="number" formControlName="imported_price_max"
                                [placeholder]="'comparator.filter.fields.imported_price_max' | translate" />

                        </div>
                    </div>
                    <div class="inputs-pair">
                        <div class="field">
                            <label for="inventory_price_min">{{ "comparator.filter.fields.inventory_price_min" |
                                translate }}</label>
                            <input id="inventory_price_min" type="number" min="0" formControlName="inventory_price_min"
                                [placeholder]="'comparator.filter.fields.inventory_price_min' | translate" />

                        </div>
                        <div class="field">
                            <label for="inventory_price_max">{{ "comparator.filter.fields.inventory_price_max" |
                                translate }}</label>
                            <input id="inventory_price_max" type="number" formControlName="inventory_price_max"
                                [placeholder]="'comparator.filter.fields.inventory_price_max' | translate" />

                        </div>
                    </div>
                    <div class="inputs-pair">
                        <div class="field">
                            <label for="other_prices_min">{{ "comparator.filter.fields.other_prices_min" | translate
                                }}</label>
                            <input id="other_prices_min" type="number" min="0" formControlName="other_prices_min"
                                [placeholder]="'comparator.filter.fields.other_prices_min' | translate" />

                        </div>
                        <div class="field">
                            <label for="other_prices_max">{{ "comparator.filter.fields.other_prices_max" | translate
                                }}</label>
                            <input id="other_prices_max" type="number" formControlName="other_prices_max"
                                [placeholder]="'comparator.filter.fields.other_prices_max' | translate" />
                        </div>
                    </div>
                    <!-- <div class="inputs-pair">
                <div class="field">
                    <label for="date_imported_from">{{ "comparator.filter.fields.date_imported_min" | translate }}</label>
                    <input id="date_imported_from" type="date" formControlName="date_imported_from" [placeholder]="'comparator.filter.fields.date_imported_min' | translate" />
                </div>
                <div class="field">
                    <label for="date_imported_to">{{ "comparator.filter.fields.date_imported_max" | translate }}</label>
                    <input id="date_imported_to" type="date" formControlName="date_imported_to" [placeholder]="'comparator.filter.fields.date_imported_max' | translate" />
                </div>
            </div> -->
                </div>
            </ng-container>
        </div>
    </div>

    <div class="footer submet_btns">
        <button class="save_btn_pop_up cancel_btn_pop_up" (click)="close()">
            <span>{{"common.cancel"|translate | uppercase}}</span>
            <img src="../../../../../assets/icones/arrow_back.svg" alt="">
        </button>
        <div class="save-apply">
            <!-- <div class="save-filter-form" *ngIf="toggleSaveFilterForm && getFiltersCount() > 0">
                <div class="label-action">
                    <label for="filter_name">{{
                        "filter.filter_name" | translate
                        }}</label>
                    <div class="actions">
                        <button class="cancel-btn" (click)="toggleSaveFilter()">{{ "common.cancel" | translate
                            }}</button>
                        <button class="save-btn" (click)="save()">
                            {{ "common.save" | translate | uppercase }}
                        </button>
                    </div>
                </div>
                <input id="filter_name" type="text" class="filter-name-input"
                    [placeholder]="'filter.filter_name' | translate" [(ngModel)]="filterName"
                    [formControl]="filterNameControl" />
                <span class="error_ms" *ngIf="filterNameControl?.touched && filterNameControl?.errors">
                    {{ "common.required_field" | translate }}
                </span>
            </div>
            <button class="save save_filter" [disabled]="getFiltersCount() <= 0" *ngIf="!toggleSaveFilterForm"
                (click)="toggleSaveFilter()">
                <img src="assets/icones/save-filter.svg" alt="" />
                <small>{{ "filter.save" | translate }}</small>
            </button> -->
            <button class="save_btn_pop_up blue_btn" (click)="applyFilter()">
                <small>{{ "filter.apply" | translate | uppercase }}</small>
                <img alt="" src="../../../../../assets/icones/arrow_circle_right.svg">
            </button>
        </div>
    </div>
</div>
